import { ReactNode } from 'react';
import { makeObservable, observable } from 'mobx';
import { IAttachment, TMessageType } from '../types';

let maxId = 0;

export class ChatMessage {
  id: number;

  constructor(
    public message: ReactNode = '',
    public messageType: TMessageType = 'user',
    public attachments: IAttachment[] = [],
    public reference: ReactNode = null,
  ) {
    this.id = maxId++;
    if (messageType === 'response') this.messageType = 'system';
    if (typeof message === 'string') this.message = message;

    makeObservable(this, {
      attachments: observable,
      message: observable,
      messageType: observable,
      reference: observable,
    });
  }

  clone = () =>
    new ChatMessage(
      this.message,
      this.messageType,
      this.attachments.map((x) => {
        return { ...x };
      }),
      this.reference,
    );

  removeAttachment(attachment: IAttachment) {
    this.attachments = this.attachments.filter(
      (current) => current !== attachment,
    );
  }
  addAttachmentDescription(attachment: IAttachment, description: string) {
    const a = this.attachments.find((current) => current === attachment);
    if (a) {
      a.description = description;
    }
  }
}
